// ✅ TripAttendancePage.js — Select crew and vehicles after accepting a trip

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function TripAttendancePage() {
  const { tripId } = useParams();
  const navigate = useNavigate();
  const [crew, setCrew] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [selectedCrewIds, setSelectedCrewIds] = useState([]);
  const [selectedVehicleIds, setSelectedVehicleIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const res = await fetch(`/api/trips/${tripId}/attendance`, {
          credentials: "include",
        });
        const data = await res.json();
        setCrew(data.crew || []);
        setVehicles(data.rides || []);
      } catch (err) {
        console.error("Error loading attendance options:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchOptions();
  }, [tripId]);

  const handleSubmit = async () => {
    try {
      const res = await fetch(`/api/trips/${tripId}/attendance`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
            attending: true,
            crew_member_ids: selectedCrewIds,
            ride_ids: selectedVehicleIds,
          }),
       });
      if (res.ok) {
        navigate(`/trip/${tripId}`);
      } else {
        const err = await res.json();
        alert("Failed to save: " + err.error);
      }
    } catch (err) {
      console.error("Error submitting attendance:", err);
    }
  };

  const toggle = (list, setList, id) => {
    setList((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  if (loading) return <p>Loading options...</p>;

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Who's coming?</h2>

        <h3>Your Crew</h3>
        {crew.length === 0 ? (
          <p>No crew members found.</p>
        ) : (
          <ul>
            {crew.map((c) => (
              <li key={c.id}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedCrewIds.includes(c.id)}
                    onChange={() => toggle(selectedCrewIds, setSelectedCrewIds, c.id)}
                  />
                  {c.name} ({c.type})
                </label>
              </li>
            ))}
          </ul>
        )}

        <h3>Your Vehicles</h3>
        {vehicles.length === 0 ? (
          <p>No vehicles found.</p>
        ) : (
          <ul>
            {vehicles.map((v) => (
              <li key={v.id}>
                <label>
                  <input
                    type="checkbox"
                    checked={selectedVehicleIds.includes(v.id)}
                    onChange={() => toggle(selectedVehicleIds, setSelectedVehicleIds, v.id)}
                  />
                  {v.make} {v.model} ({v.type})
                </label>
              </li>
            ))}
          </ul>
        )}

        <button onClick={handleSubmit} style={{ marginTop: "20px" }}>Save & Return to Trip</button>
      </div>
    </div>
  );
}
